<template>
  <el-main>
    <div class="control-bar">
      <span class="title">权限管理</span>
      <el-form inline size="small">
        <el-form-item v-if="admin.actions.indexOf('isadd') != -1">
          <el-button type="primary" size="small" @click="addForm(null)">添加权限</el-button>
        </el-form-item>
        <el-form-item v-if="flag>1">
          <el-button type="primary" circle icon="ca ca-reback" @click="getLists(2,returnPid)"></el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="lists" border empty-text="暂无数据">
      <el-table-column prop="mid" label="MID" align="center" width="100px">
      </el-table-column>
      <el-table-column prop="name" label="权限名称"></el-table-column>
      <el-table-column prop="icon" label="图标"></el-table-column>
      <el-table-column prop="controlle" label="控制器"></el-table-column>
      <el-table-column prop="method" label="方法">
      </el-table-column>
      <el-table-column label="操作" align="center" width="200px">
        <template slot-scope="scope">
          <el-button size="mini" icon="el-icon-edit" circle type="primary" @click="addForm(scope.row)"></el-button>
          <el-button size="mini" icon="el-icon-delete" circle type="primary" @click="deleteMenu(scope.row)"></el-button>
          <el-button size="mini" icon="el-icon-arrow-down" type="primary" circle @click="getLists(1,scope.row.mid)"
            v-if="flag < flagMax"></el-button>
          <el-button size="mini" icon="el-icon-arrow-up" type="primary" circle @click="getLists(2,returnPid)"
            v-if="flag > 1"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="addFormTitle" :visible.sync="addFormVisible" width="500px" append-to-body>
      <el-form :model="detail" ref="addForm" label-width="100px" :rules="rules">
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="detail.name"></el-input>
        </el-form-item>
        <el-form-item label="权限图标" prop="name">
          <el-input v-model="detail.icon"></el-input>
        </el-form-item>
        <el-form-item label="控制器" prop="name">
          <el-input v-model="detail.controlle"></el-input>
        </el-form-item>
        <el-form-item label="方法" prop="name">
          <el-input v-model="detail.method"></el-input>
        </el-form-item>
        <el-form-item>
          <el-row type="flex">
            <el-button type="primary" @click="submitForm('addForm')">提交</el-button>
          </el-row>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>
<script>
  import {
    httpRequest,
    getCookie
  } from '@/utils/app'

  import Sortable from 'sortablejs'

  export default {
    data() {
      return {
        admin: {
          actions: []
        },
        flag: 1,
        flagMax: 2,
        pid: 0,
        returnPid: 0,
        addFormVisible: false,
        addFormTitle: '添加权限',
        detail: {},
        lists: [],
        rules: {
          name: [{
            required: true,
            message: '请输入权限名称',
            trigger: 'blur'
          }]
        }
      }
    },
    mounted() {
      this.admin = getCookie('admin')
      // 列表拖动
      const that = this
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      Sortable.create(tbody, {
        sort: true,
        animation: 150,
        onEnd(evt) {
          const sortData = []
          for (let i = 0; i < evt.from.children.length; i++) {
            sortData[i] = parseInt(evt.from.children[i].cells[0].innerText)
          }
          httpRequest({
            action: 'adminMenu_ord',
            ords: encodeURIComponent(JSON.stringify(sortData))
          })
        }
      })
      this.getLists()
    },
    methods: {
      getLists(doflag, pid) {
        if (doflag) {
          this.flag = doflag === 1 ? this.flag + 1 : this.flag - 1
          this.pid = pid
          // 获取当前分类父级分类
          if (this.flag === 2) {
            httpRequest({
              action: 'adminMenu_detail',
              mid: this.pid
            }).then(response => {
              this.returnPid = response.data.pid
            })
          }
        }
        httpRequest({
          action: 'adminMenu_lists',
          offset: 100,
          pid: this.pid
        }).then(response => {
          this.lists = response.data
        })
      },
      deleteMenu(row) {
        let that = this
        httpRequest({
          action: "adminMenu_delete",
          mid: row.mid
        }, 'post').then(response => {
          if (response.error) {
            this.$message({
              type: 'error',
              message: response.msg
            })
          } else {
            this.$message({
              type: 'success',
              message: '操作成功!',
              duration: 1000,
              onClose: function() {
                that.getLists();
              }
            })
          }
        })
      },
      addForm(row) {
        this.detail = {
          mid: 0,
          pid: this.pid,
          name: '',
          controlle: '',
          method: '',
          icon: ''
        }
        if (row) {
          this.addFormTitle = '编辑权限'
          this.detail = row
        } else {
          this.addFormTitle = '添加权限'
        }
        this.addFormVisible = true
      },
      submitForm(formName) {
        const that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            httpRequest({
              action: 'adminMenu_add',
              mid: this.detail.mid,
              pid: this.detail.pid,
              icon: this.detail.icon,
              name: this.detail.name,
              controlle: this.detail.controlle,
              method: this.detail.method
            }).then(response => {
              if (!response.error) {
                this.$message({
                  type: 'success',
                  message: '操作成功!',
                  duration: 1000,
                  onClose: function() {
                    that.getLists()
                    that.addFormVisible = false
                  }
                })
              }
            })
          } else {
            return false
          }
        })
      },
      handleEdit(index, item) {
        this.addFormVisible = item
        this.addFormTitle = '编辑权限'
      }
    }
  }
</script>